import store from '@/store'

/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export default {
  install(Vue) {
    Vue.prototype.checkPermission = (value) => {
      const accessPermissionList = value
      if (accessPermissionList && accessPermissionList instanceof Array && accessPermissionList.length > 0) {
        const role = store.getters && store.getters.role
        const permissionList = store.getters && store.getters.permissions
        if (role !== 'ADMIN') {
          return permissionList.some(permission => {
            return accessPermissionList.includes(permission)
          })
        } else {
          return true
        }
      } else {
        console.error(`need roles! Like v-permission="['admin','editor']"`)
        return false
      }
    }
  }
}
